import React from "react";
import { motion } from "framer-motion";

const sponsors = Array.from({ length: 6 }).map((_, i) => ({
  id: i + 1,
  label: "Sponsor Space",
  href: "#",
}));

export const SectionSponsors = () => {
  return (
    <section id="sponsors" className="w-full py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto text-center">

          <motion.h2
            className="text-3xl md:text-5xl font-black text-lime-600 tracking-wider mb-4"
            initial={{ opacity: 0, y: -15 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            SPONSOR SPACE
          </motion.h2>

          <motion.p
            className="text-lg font-normal text-lime-800 max-w-3xl mx-auto mb-12 px-4"
            initial={{ opacity: 0, y: -15 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            We are open for sponsorship and partnership opportunities for JOTR Cianjur Series 2026.
          </motion.p>

          <motion.div
            className="grid grid-cols-2 sm:grid-cols-3 gap-4 px-4 max-w-4xl w-full mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            {sponsors.map((s, idx) => (
              <motion.div
                key={s.id}
                className="relative group rounded-2xl overflow-hidden cursor-pointer flex items-center justify-center bg-transparent"
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.45,
                  delay: 0.03 * idx,
                  ease: "easeInOut",
                }}
                viewport={{ once: true }}
              >
                <button
                  type="button"
                  onClick={() => s.href !== "#" && window.open(s.href, "_blank", "noopener,noreferrer")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      s.href !== "#" && window.open(s.href, "_blank", "noopener,noreferrer");
                    }
                  }}
                  aria-label={`Sponsor slot ${s.id}`}
                  className="w-full h-20 md:h-24 flex items-center justify-center rounded-xl bg-slate-100 text-slate-400 font-normal uppercase tracking-wide px-3 transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-lime-500 focus-visible:ring-offset-2"
                >
                  <span className="text-sm md:text-base lg:text-lg">{s.label}</span>
                </button>
              </motion.div>
            ))}
          </motion.div>

        </div>
      </div>
    </section>
  );
};